import { render } from "./HireMe.vue?vue&type=template&id=b2bf10a0"
import script from "./HireMe.vue?vue&type=script&lang=js"
export * from "./HireMe.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gokaysen/Desktop/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__